import { render, staticRenderFns } from "./BatchHistory.template.vue?vue&type=template&id=4b50fa8e&scoped=true&"
var script = {}
import style0 from "./BatchHistory.template.vue?vue&type=style&index=0&id=4b50fa8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50fa8e",
  null
  
)

export default component.exports